import {ArrayPath, Path, useFieldArray, useFormContext} from 'react-hook-form';
import * as React from 'react';
import {FormHelperText, Grid, IconButton, useTheme} from '@mui/material';
import {OutlinedAddButton} from "../../components/buttons/OutlinedAddButton";
import {retrieveError} from "../../components/forms/formUtils";
import {useTranslation} from "react-i18next";
import {TranslatedValue} from "./TranslatedValue";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import {MuiRhfLanguagesField} from "./MuiRhfLanguagesField";
import {MuiRhfTextField} from "../../components/forms/MuiRhfTextField";

export function TranslatedValuesForm<TFieldValues>(props: {
  name: string,
  label?: string,
  fullWidth?: boolean,
  required?: boolean,
  disabled?: boolean
}) {
  const {name} = props;
  const theme = useTheme();
  const {t} = useTranslation();
  const {control, formState: {errors}} = useFormContext<TFieldValues>();
  const {fields, append, remove} = useFieldArray<TFieldValues>({
    control: control,
    name: name as ArrayPath<TFieldValues>
  });

  if (fields.length === 0 && props.disabled) {
    return <></>
  }
  return (
    <Grid container={true}>
      <Grid item={true} lg={12} sx={{
        display: 'flex',
        alignItems: 'center',
        '& > *': {
          marginRight: theme.spacing(2)
        }
      }}>
        {!props.disabled &&
          <OutlinedAddButton size={'small'} onClick={() => append({} as any)} title={t('TranslatedValue.btnAddLanguage')}/>
        }
      </Grid>
      {retrieveError(name, errors) &&
        <FormHelperText error={true}>{retrieveError(name, errors)}</FormHelperText>
      }
      {fields.map((translatedValue: any, index: number) =>
        <TranslatedValueItemForm translatedValue={translatedValue} index={index} remove={remove} disabled={props.disabled}
                                 key={index} namePrefix={name}/>
      )}
    </Grid>
  );
}

export function TranslatedValueItemForm<TFieldValues>(props: {
  namePrefix: string,
  translatedValue: TranslatedValue,
  index: number,
  remove: (index?: number | number[]) => void,
  disabled?: boolean
}) {
  const theme = useTheme();
  const {t} = useTranslation();

  return (
    <Grid container={true} spacing={3} sx={{marginTop: theme.spacing(1),}} key={props.index}>
      <Grid item={true} xs={5}>
        <MuiRhfLanguagesField name={`${props.namePrefix}.${props.index}.language`} disabled={props.disabled}/>
      </Grid>
      <Grid item={true} xs={5}>
        <MuiRhfTextField
          name={`${props.namePrefix}.${props.index}.translation` as Path<TFieldValues>}
          label={t('TranslatedValue.translation')}
          variant={'standard'}
          fullWidth={true}
          disabled={props.disabled}
        />
      </Grid>
      {!props.disabled &&
        <Grid item={true} xs={2} sx={{display: 'flex', alignItems: 'center', marginLeft: 'auto', justifyContent: 'center'}}>
          <IconButton
            onClick={() => props.remove(props.index)}
            size="large" sx={{color: theme.palette.primary.dark,}}>
            <DeleteOutlineIcon/>
          </IconButton>
        </Grid>
      }
    </Grid>
  );
}
